import { getOrdersList } from "./api";
import { typeOrdersFilters } from "./reducer";
import { put, call, takeLatest } from "redux-saga/effects";
import { typePagination, typeRequestPagination } from "../system/constants";
import {
  dOrdersArchiveSetDataAC,
  dOrdersArchiveSetDataSagaAC,
  dOrdersArchiveSetPaginationAC,
} from "./actionCreators";
import {
  logoutSagaAC,
  addNotificationAC,
  dashboardLoaderAC,
} from "../system/systemActionCreators";

export const paginationMapper = (paginationObject: any): typePagination => {
  return {
    pageNumber: paginationObject.pageNumber,
    pageCount: paginationObject.totalPages,
    totalItems: paginationObject.totalElements,
    isFirstPage: paginationObject.pageNumber === 0,
    isLastPage: paginationObject.pageNumber + 1 === paginationObject.totalPages,
  };
};

function* getData(payload: {
  filters: typeOrdersFilters;
  paginationRequest: typeRequestPagination;
}) {
  let response = yield call(getOrdersList, payload);

  if (response.status === 200) {
    const pagination: typePagination = paginationMapper(response.data);

    yield put(dOrdersArchiveSetPaginationAC(pagination));

    yield put(dOrdersArchiveSetDataAC(response.data.content));
  } else {
    yield errorGenerator(response);
  }
}

function* errorGenerator(response: any) {
  if (response.status === 401) {
    yield put(logoutSagaAC());
  } else if (
    response.status === 400 &&
    response.data.description === "Order can not be changed"
  ) {
    const id = new Date();
    yield put(
      addNotificationAC({
        id: id.getTime().toString(),
        message: "ERROR_ORDER_CANNOT_BE_CHANGED",
      }),
    );
  } else {
    const id = new Date();
    yield put(
      addNotificationAC({
        id: id.getTime().toString(),
        message: "ERROR_SERVER_CONNECTION",
      }),
    );
  }
  console.log(response);
}

export function* dOrdersArchiveSetDataWorker(actionObject: {
  type: string;
  payload: {
    filters: typeOrdersFilters;
    paginationRequest: typeRequestPagination;
  };
}) {
  yield put(dashboardLoaderAC(true));

  yield getData(actionObject.payload);

  yield put(dashboardLoaderAC(false));
}

export function* dOrdersArchiveSetDataWatcher() {
  yield takeLatest(
    dOrdersArchiveSetDataSagaAC.type,
    dOrdersArchiveSetDataWorker,
  );
}
